export default {
    logo: require("../assets/images/logo-gtm-2024.png"),
    golf_field: require("../assets/images/field_golf.jpg"),
    field_golf: require("../assets/images/golf_field.png"),
    strategie: require("../assets/images/strategie.jpg"),
    Industry: require("../assets/images/Industry.jpg"),
    IONIQ: require("../assets/images/IONIQ.jpg"),
    mission: require("../assets/images/Rectangle_8.png"),
    temoign: require("../assets/images/Rectangle_10.png"),
    icon: require("../assets/images/carbon_play-outline.png"),
    france_logo: require("../assets/images/france_logo.avif"),
    usa_logo: require("../assets/images/usa_logo.png"),
    BACKGROUND_2: require("../assets/images/golf_people.jpg"),
    ceo: require("../assets/images/Screenshot_3-3-2025_144143_www.figma.com.jpeg"),
    m2m: require("../assets/images/2M.webp"),
    achewa9e3: require("../assets/images/achewa9e3.webp"),
    almaghribialyaoum: require("../assets/images/almaghribialyaoum.webp"),
    casa24: require("../assets/images/casa24.ma_.webp"),
    chaineactu: require("../assets/images/chaineactu.webp"),
    golfbusinessmonitor: require("../assets/images/golfbusinessmonitor.webp"),
    hibapress: require("../assets/images/hibapress.webp"),
    manbar24: require("../assets/images/manbar24.webp"),
    moroccanzoom: require("../assets/images/moroccanzoom.webp"),
    msport: require("../assets/images/msport.webp"),
    opinion: require("../assets/images/opinion.webp"),
    media1: require("../assets/images/media1.webp"),
    assoufid: require("../assets/images/assoufid-gc-1st-hole.jpg"),
    palm: require("../assets/images/palm-golf-ourika-marrakech-1536x665.jpg"),
    tournament: require("../assets/images/tournament-in-morocco-064a7985.jpg"),
    anothter: require("../assets/images/anothter-golf-tournament-in-morocco-064a8735.jpg"),
    andalouse: require("../assets/images/andalouse.jpg"),
    golfAndNetworking: require("../assets/images/golfAndNetworking.jpg"),
    profil_pic: require("../assets/images/profil_pic.jpg"),
    bronze: require("../assets/images/memberTypes/bronze.png"),
    gold: require("../assets/images/memberTypes/gold.png"),
    platinum: require("../assets/images/memberTypes/paltinume.png"),
    photo_benzakour: require("../assets/images/photo-hicham-benzakour.png"),
    Frame: require("../assets/images/Frame.png"),
    program2025: require("../assets/images/program2025.jpg"),
    bridgeOf: require("../assets/images/Bridge-of-Cultures.jpg"),
    about: require("../assets/images/about.jpg"),
    clarity_event: require("../assets/images/clarity_event-line.png"),
    mdi_partnership: require("../assets/images/mdi_partnership-outline.png"),
    fluent_payment: require("../assets/images/fluent_payment-20-regular.png"),
    gold_fram: require("../assets/images/GTM-APP-icons/gold-photo-profile.png"),
    sold: require("../assets/images/sold-out.png"),
    bronze: require("../assets/images/GTM-APP-icons/bronze-photo-profile.png"),
    gold: require("../assets/images/GTM-APP-icons/gold-photo-profile.png"),
    visiteur: require("../assets/images/GTM-APP-icons/visiteur-photo-profile.png"),
    platinum: require("../assets/images/GTM-APP-icons/platinum-photo-profile.png"),
    gold_logo: require("../assets/images/GTM-APP-icons/gold-logo.png"),
    bronze_logo: require("../assets/images/GTM-APP-icons/bronze-logo.png"),
    platinum_logo: require("../assets/images/GTM-APP-icons/platinum-logo.png"),
    visiteur_logo: require("../assets/images/GTM-APP-icons/visiteur-logo.png"),
    visiteur_menu: require("../assets/images/GTM-APP-icons/visiteur-menu-bar.png"),
    menu_visit: require("../assets/images/GTM-APP-icons/menu_visit.png"),
    platinum_menu: require("../assets/images/GTM-APP-icons/platinum-menu-bar.png"),
    gold_menu: require("../assets/images/GTM-APP-icons/gold-menu-bar.png"),
    bronze_menu: require("../assets/images/GTM-APP-icons/bronze-menu-bar.png"),
    goldd: require("../assets/images/GTM-APP-icons/Group_1000001124.png"),
    bronz: require("../assets/images/GTM-APP-icons/Group_1000001126.png"),
    platin: require("../assets/images/GTM-APP-icons/Group_1000001125.png"),
    gtm_rolex: require("../assets/images/gtm_rolex.png"),
    bigsmoke: require("../assets/images/bigsmoke.jpg"),
    art: require("../assets/images/art_new.png"),
    cars: require("../assets/images/cars.jpg"),
    inittiaiton: require("../assets/images/inittiaiton.jpg"),
    sold_out: require("../assets/images/sold-out.png"),
    sunset:require("../assets/images/sunset.png"),
    avene:require("../assets/images/partenaire_images/avene.jpg"),
    foodsgoods:require("../assets/images/partenaire_images/foodsgoods.jpg"),
    hitradio:require("../assets/images/partenaire_images/hitradio.jpg"),
    korean:require("../assets/images/partenaire_images/korean.jpg"),
    mediaglobal:require("../assets/images/partenaire_images/mediaglobal.jpg"),
    sport:require("../assets/images/partenaire_images/sport.jpg"),
    women:require("../assets/images/partenaire_images/women.jpg"),
    press:require("../assets/images/press.png"),
    longdrive:require("../assets/images/longdrive.jpg"),
    carbon_play:require("../assets/images/carbon_play-outline.png"),
    gentdriver:require("../assets/images/gentdriver.jpeg"),
    magazine:require("../assets/images/magazine.jpg"),
}
